import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import MixrGroupListItem from 'srcReact/components/common2/MixrGroupListItem'
import Button from 'srcReact/components/common2/Button'
import Avatar from 'srcReact/components/common2/Avatar'
import Divider from 'srcReact/components/common2/Divider'
import IconButton from 'srcReact/components/common2/IconButton'

function SelectGroup({ dataToTransfer, groups, selectMembersForGroup }) {
  const { t } = useTranslation()
  return (
    <div className={styles.container}>
      {dataToTransfer.size > 0 && (
        <div className={styles.processedGroups}>
          {[...dataToTransfer.entries()].map(([groupId, value], index) => {
            const { group, user } = value
            return (
              <div className={styles.processedGroupItem}>
                <MixrGroupListItem
                  type='group'
                  id={group.id}
                  title={group.name}
                  titleCSS={styles.processedGroupName}
                  picture={group.picture.path}
                />
                <div className={styles.selectedUser}>
                  <IconButton
                    iconName='update'
                    iconSize='large24'
                    className={styles.btnUpdateMember}
                    onClick={() => selectMembersForGroup(group.id)}
                  />
                  <div className={styles.userInfo}>
                    <Avatar
                      key={'member_' + user.id}
                      userId={user.id}
                      profilePicture={user.profile_picture_url}
                      firstname={user.firstname}
                      lastname={user.lastname}
                      imgWrapperSize='tiny'
                      mimeType={user.mime_type}
                      originalTag={user.original_tag}
                      isOriginal={user.is_original}
                      withExpertiseGroup={user.with_expertise_group}
                    />
                    <div className={styles.userName}>{`${user.firstname} ${user.lastname}`}</div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      )}
      {dataToTransfer.size > 0 && dataToTransfer.size < groups.groups_to_transfer.length > 0 && (
        <Divider className={styles.divider} />
      )}
      <div className={styles.groups}>
        {groups &&
          groups.groups_to_transfer.length > 0 &&
          groups.groups_to_transfer
            .filter((group) => dataToTransfer.get(group.id) == null)
            .map((group) => (
              <MixrGroupListItem
                type='group'
                id={group.id}
                title={group.name}
                titleCSS={styles.groupName}
                className={styles.groupListContainer}
                picture={group.picture.path}
                renderCustomAction={() => (
                  <Button
                    handleClick={() => selectMembersForGroup(group.id)}
                    customStyle={styles.btnSelect}
                    text={t('global.selectMember')}
                  />
                )}
              />
            ))}
      </div>
    </div>
  )
}

export default SelectGroup
